export default "__VITE_ASSET__By5RmaTJ__"